export type MembershipTierCode = 'ATRIUM' | 'HERMES' | 'APOLLO';

const TIER_LABELS: Record<MembershipTierCode, string> = {
  ATRIUM: 'Atrium',
  HERMES: 'Hermes',
  APOLLO: 'Apollo',
};

export const normalizeMembershipTier = (value: string | null | undefined): MembershipTierCode => {
  const normalized = value?.toUpperCase();
  if (normalized === 'HERMES' || normalized === 'APOLLO' || normalized === 'ATRIUM') {
    return normalized;
  }
  return 'ATRIUM';
};

export const formatMembershipTier = (value: string | null | undefined): string => {
  return TIER_LABELS[normalizeMembershipTier(value)];
};

export const formatProfileBadgeLabel = (
  membershipTier: string | null | undefined,
  role: string | null | undefined,
): string => {
  const normalizedRole = role?.toLowerCase();
  if (normalizedRole === 'admin' || normalizedRole === 'super_admin') return 'Admin';
  return formatMembershipTier(membershipTier);
};
